<form #form="ngForm" column-classes="col-md-4,col-md-8">
  @if (_template) {
    <div class="row">
      <div class="col-md-6 col-xs-12">
        <cap-auftrag-export-selection [(ngModel)]="_template" [readonly]="readonly" name="grundstueck-selection">
        </cap-auftrag-export-selection>
        <div class="mt-3">
          @if (_template.mPersonartSelection.access !== "DEACTIVATED") {
            <cap-auftrag-personart-selection
              (ngModelChange)="_template && (_template.personartSelection = $event)"
              [disabled]="disabled"
              [ngModel]="_template && _template.personartSelection"
              name="personartSelection">
            </cap-auftrag-personart-selection>
          }
        </div>
        <div class="mt-3">
          @if (_template.mRubrikSelection.access !== "DEACTIVATED") {
            <cap-auftrag-rubrik-selection
              (ngModelChange)="_template && (_template.rubrikSelection = $event)"
              [disabled]="disabled"
              [ngModel]="_template && _template.rubrikSelection"
              name="rubrikSelection">
            </cap-auftrag-rubrik-selection>
          }
        </div>
        <div class="mt-3">
          @if (_template.mAenderungsDatumSelection.access !== "DEACTIVATED") {
            <cap-auftrag-datum-selection
              (ngModelChange)="_template && (_template.aenderungsDatumSelection = $event)"
              [disabled]="disabled"
              [heading]="'GrundstueckMitAenderungen'"
              [ngModel]="_template && _template.aenderungsDatumSelection"
              name="aenderungsDatumSelection">
            </cap-auftrag-datum-selection>
          }
        </div>
        <div class="mt-3">
          @if (_template.mLoeschungsDatumSelection.access !== "DEACTIVATED") {
            <cap-auftrag-datum-selection
              (ngModelChange)="_template && (_template.loeschungsDatumSelection = $event)"
              [disabled]="disabled"
              [heading]="'GeloeschteGrundstuecke'"
              [ngModel]="_template && _template.loeschungsDatumSelection"
              name="loeschungsDatumSelection">
            </cap-auftrag-datum-selection>
          }
        </div>
        <div class="mt-3">
          @if (_template.mRechteSelection.access !== "DEACTIVATED") {
            <cap-auftrag-rechte-selection
              (ngModelChange)="_template && (_template.rechteSelection = $event)"
              [disabled]="disabled"
              [ngModel]="_template && _template.rechteSelection"
              name="rechteSelection">
            </cap-auftrag-rechte-selection>
          }
        </div>
      </div>
      <div class="col-md-6 col-xs-12">
        @if (_template.mGrundstueckTyp.access !== "DEACTIVATED") {
          <cap-auftrag-grundstuecktype-selection
            (ngModelChange)="_template && (_template.grundstueckTyp = $event)"
            [disabled]="disabled"
            [ngModel]="_template && _template.grundstueckTyp"
            name="grundstueckTyp">
          </cap-auftrag-grundstuecktype-selection>
        }
        <div class="mt-3">
          @if (_template.mBodenbedeckungSelection.access !== "DEACTIVATED") {
            <cap-auftrag-bodenbedeckung-selection
              (ngModelChange)="_template && (_template.bodenbedeckungSelection = $event)"
              [disabled]="disabled"
              [mitBodenbedeckungsGeschichte]="_template?.exportTyp !== 'BODENBEDECKUNGSFILTER'"
              [ngModel]="_template && _template.bodenbedeckungSelection"
              [template]="_template && _template.bodenbedeckungSelection"
              name="bodenbedeckungSelection">
            </cap-auftrag-bodenbedeckung-selection>
          }
        </div>
      </div>
    </div>
  }

  @if (!readonly) {
    <div class="p-2" id="actionpane">
      <div class="rechtsbuendig">
        <button cdkStepperPrevious class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurück" | translate }}</button>
        <button class="btn btn-outline-primary" routerLink=".." type="button">{{ "Abbrechen" | translate }}</button>
        <button (click)="validateAndGoToNextStep()" class="btn btn-primary btn-actionpane" type="button">{{ "Weiter" | translate }}</button>
      </div>
    </div>
  }
</form>
